import Condition from "../../core/condition";
import KeyboardRenderer from "../keyboard-renderer";
import { RenderingStatus } from "./canvas-renderer";
const DEFAULT_CROP = [0, 0, 0, 0];
export default class MapRenderer extends KeyboardRenderer {
    constructor() {
        super(...arguments);
        this.keys = new Set();
    }
    reset(data) {
        super.reset(data);
        data.heroes.forEach(hero => {
            if (hero.position) {
                delete hero.position;
            }
        });
        delete data.moveAction;
        data.stepsTaken = 0;
    }
    createKeyHandlerUp(data) {
        return (e) => {
            this.keys.delete(e.code);
            delete data.moveAction;
        };
    }
    createKeyHandlerDown(data) {
        return (e) => {
            e.preventDefault();
            this.keys.add(e.code);
            if (!data.moveAction) {
                data.moveAction = { x: 0, y: 0 };
            }
            switch (e.code) {
                case "KeyW":
                case "ArrowUp":
                    data.moveAction.x = 0;
                    data.moveAction.y = -1;
                    break;
                case "KeyS":
                case "ArrowDown":
                    data.moveAction.x = 0;
                    data.moveAction.y = 1;
                    break;
                case "Space":
                    this.performAction(data, data.spaceAction, { rand: Math.random() });
                    break;
                case "ArrowLeft":
                case "KeyA":
                    data.moveAction.x = -1;
                    data.moveAction.y = 0;
                    break;
                case "ArrowRight":
                case "KeyD":
                    data.moveAction.x = 1;
                    data.moveAction.y = 0;
                    break;
            }
        };
    }
    saveReturnData(data) {
        var _a, _b;
        return {
            scene: data.title,
            subtitle: data.subtitle,
            position: {
                x: (_a = data.heroes[0].fromPosition) === null || _a === void 0 ? void 0 : _a.x,
                y: (_b = data.heroes[0].fromPosition) === null || _b === void 0 ? void 0 : _b.y,
            },
        };
    }
    getLeaderIndex(data) {
        var _a, _b, _c;
        const heroStats = (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.stats) === null || _c === void 0 ? void 0 : _c.heroes;
        for (let i = 0; i < data.heroes.length; i++) {
            if (!Condition.eval(data.heroes[i].hidden, { scene: data }) && (heroStats === null || heroStats === void 0 ? void 0 : heroStats[data.heroes[i].id].hp)) {
                return i;
            }
        }
        return 0;
    }
    performRendering(data, timestamp) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (this.context) {
            (_a = this.context) === null || _a === void 0 ? void 0 : _a.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        }
        data.heroes.forEach(hero => {
            var _a;
            if (hero && !hero.position) {
                if (data.returnPosition) {
                    hero.moveTo(data.returnPosition.x, data.returnPosition.y, timestamp, true);
                }
                else {
                    (_a = data.grid) === null || _a === void 0 ? void 0 : _a.forEach((row, gy) => {
                        row.forEach((cell, gx) => {
                            var _a;
                            if ((_a = data.tiles[cell]) === null || _a === void 0 ? void 0 : _a.startPosition) {
                                hero.moveTo(gx, gy, timestamp, true);
                            }
                        });
                    });
                }
            }
        });
        const leaderIndex = this.getLeaderIndex(data);
        let mainHero = data.heroes[leaderIndex];
        //    data.persist?.game.inventory
        if (!data.moveAction) {
            data.moveAction = { x: 0, y: 0 };
        }
        if (!mainHero.isMoving(timestamp)) {
            const underTile = mainHero.getTileUnderneath(data);
            if ((underTile === null || underTile === void 0 ? void 0 : underTile.portal) && !Condition.eval(underTile.portalDisabled, { scene: data })) {
                data.destination = underTile.portal;
                data.destinationPosition = underTile.portalPosition;
                data.destinationDirection = underTile.portalDirection;
            }
            else {
                if (data.movePending) {
                    data.movePending = false;
                    data.stepsTaken = ((_b = data.stepsTaken) !== null && _b !== void 0 ? _b : 0) + 1;
                    if (data.stepsTaken > 1 && this.onCellActions(data)) {
                        data.moveAction.x = 0;
                        data.moveAction.y = 0;
                    }
                }
                if (data.moveAction.x || data.moveAction.y) {
                    if (mainHero.canMoveBy(data.moveAction.x, data.moveAction.y, data)) {
                        mainHero.moveBy(data.moveAction.x, data.moveAction.y, timestamp);
                        data.movePending = true;
                        let leadingHero = mainHero;
                        for (let i = data.heroes.indexOf(leadingHero) + 1; i < data.heroes.length; i++) {
                            const nextHero = data.heroes[i];
                            if (nextHero) {
                                const heroStat = (_d = (_c = data.persist) === null || _c === void 0 ? void 0 : _c.game.stats) === null || _d === void 0 ? void 0 : _d.heroes[nextHero.id];
                                if (Condition.eval(nextHero.hidden, { scene: data }) || !(heroStat === null || heroStat === void 0 ? void 0 : heroStat.hp)) {
                                    continue;
                                }
                                nextHero.moveTo(leadingHero.fromPosition.x, leadingHero.fromPosition.y, timestamp);
                                leadingHero = nextHero;
                            }
                        }
                        this.autoSave(data);
                    }
                }
            }
        }
        const mainHeroPosition = mainHero.getPosition(timestamp);
        const gridWidth = (_e = data.gridWidth) !== null && _e !== void 0 ? _e : 0;
        const gridHeight = (_f = data.gridHeight) !== null && _f !== void 0 ? _f : 0;
        for (let cy = -3; cy <= 4; cy++) {
            for (let cx = -3; cx <= 4; cx++) {
                const gx = Math.floor((_g = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.x) !== null && _g !== void 0 ? _g : 0) + cx;
                const gy = Math.floor((_h = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.y) !== null && _h !== void 0 ? _h : 0) + cy;
                const cell = (_l = (_k = (_j = data.grid) === null || _j === void 0 ? void 0 : _j[gy]) === null || _k === void 0 ? void 0 : _k[gx]) !== null && _l !== void 0 ? _l : '';
                const tile = (_m = data.tiles[cell]) !== null && _m !== void 0 ? _m : data.defaultTile;
                (_o = tile === null || tile === void 0 ? void 0 : tile.images) === null || _o === void 0 ? void 0 : _o.forEach(animation => {
                    var _a, _b, _c, _d, _e;
                    if (Condition.eval(animation.hidden, { scene: data })) {
                        return;
                    }
                    if (this.context && (animation === null || animation === void 0 ? void 0 : animation.asset)) {
                        const timeEllapsed = timestamp - ((_a = data.startTime) !== null && _a !== void 0 ? _a : 0);
                        const frame = timeEllapsed && (animation === null || animation === void 0 ? void 0 : animation.frameRate) ? Math.floor(animation.frameRate * timeEllapsed / 1000) : 0;
                        const [x, y, width, height] = (_b = animation === null || animation === void 0 ? void 0 : animation.getCrop(frame)) !== null && _b !== void 0 ? _b : DEFAULT_CROP;
                        this.context.drawImage((_c = animation === null || animation === void 0 ? void 0 : animation.asset) === null || _c === void 0 ? void 0 : _c.image, x, y, width, height, Math.round((gx - ((_d = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.x) !== null && _d !== void 0 ? _d : 0) + 3) * gridWidth), Math.round((gy - ((_e = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.y) !== null && _e !== void 0 ? _e : 0) + 3) * gridHeight), width, height);
                    }
                });
            }
        }
        const sortedHeroes = [...data.heroes]
            .filter(({ id }) => { var _a, _b, _c; return (_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes[id !== null && id !== void 0 ? id : 0]) === null || _c === void 0 ? void 0 : _c.hp; })
            .filter(({ hidden }) => !Condition.eval(hidden, { scene: data }))
            .sort((hero1, hero2) => {
            var _a, _b;
            const pos1 = hero1.getPosition(timestamp);
            const pos2 = hero2.getPosition(timestamp);
            if ((pos1 === null || pos1 === void 0 ? void 0 : pos1.y) === (pos2 === null || pos2 === void 0 ? void 0 : pos2.y)) {
                return data.heroes.indexOf(hero2) - data.heroes.indexOf(hero1);
            }
            return ((_a = pos1 === null || pos1 === void 0 ? void 0 : pos1.y) !== null && _a !== void 0 ? _a : 0) < ((_b = pos2 === null || pos2 === void 0 ? void 0 : pos2.y) !== null && _b !== void 0 ? _b : 0) ? -1 : 1;
        });
        sortedHeroes.forEach(hero => {
            var _a, _b, _c, _d;
            const animation = hero.getAnimation();
            if (this.context && ((_a = animation.asset) === null || _a === void 0 ? void 0 : _a.image)) {
                const [x, y, width, height] = animation.getCrop(hero.isMoving(timestamp) ? animation.getFrame(timestamp, hero.moveTime) % animation.getTotalFrames() : 1);
                const pos = hero.getPosition(timestamp);
                if (pos) {
                    const gx = pos.x + 3.5;
                    const gy = pos.y + 4;
                    this.context.drawImage((_b = animation.asset) === null || _b === void 0 ? void 0 : _b.image, x, y, width, height, Math.round((gx - ((_c = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.x) !== null && _c !== void 0 ? _c : 0)) * gridWidth - 8), Math.round((gy - ((_d = mainHeroPosition === null || mainHeroPosition === void 0 ? void 0 : mainHeroPosition.y) !== null && _d !== void 0 ? _d : 0)) * gridHeight - 16), width, height);
                }
            }
        });
        return data.destination ? RenderingStatus.COMPLETED : RenderingStatus.RENDERING;
    }
    onCellActions(data) {
        var _a;
        const chance = { rand: Math.random() };
        let didAction = false;
        for (let action of (_a = data.onCellActions) !== null && _a !== void 0 ? _a : []) {
            if (this.performAction(data, action, chance)) {
                didAction = true;
            }
        }
        return didAction;
    }
    getConnectionTag(data) {
        var _a, _b;
        if (!((_a = data.heroes[0]) === null || _a === void 0 ? void 0 : _a.position)) {
            return;
        }
        const { x, y } = data.heroes[0].position;
        return `${data.title}|${(_b = data.subtitle) !== null && _b !== void 0 ? _b : ''}|${x},${y}`;
    }
}
